import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './component.html',
  styleUrls: ['./component.css']
})
export class UNIBICComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
